export default "__VITE_ASSET__CAyVgM$1__"